import type { Square } from '../game/types.js';
import { DEFAULT_BOARD_SIZE } from '../utils/constants.js';

/**
 * Convert a board square to its algebraic name from White's perspective.
 *
 * Canonical board orientation: White starts at the highest row indices and
 * promotes on row 0. Algebraic ranks count up from White's back rank, so
 *   row 7 → rank "1" (White's home),
 *   row 0 → rank "8" (Black's back / White's promotion row).
 * Files go a–h left-to-right as White sees the board, matching column index
 * 0 → 'a' … 7 → 'h'. This naming is global and rotation-independent so a
 * screen-reader user always hears the same name for the same square,
 * regardless of which colour the local seat plays.
 */
export function squareToAlgebraic(square: Square): string {
  const file = String.fromCharCode('a'.charCodeAt(0) + square.col);
  const rank = String(DEFAULT_BOARD_SIZE - square.row);
  return `${file}${rank}`;
}
